define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var CashierMethodModel = require('portlets/cashier/cashier.method.model');
    var server = require('server');
    var config = require('config');

    module.exports = CashierMethodModel.extend({

        configType: '.withdraw',
        accountSortField: 'lastWithdrawTime',

        getRequestData: function(data) {
            var methodCode = this.get('code');

            if (methodCode === 'VisaCheckout') {
                methodCode = _.findWhere(this.get('account'), { code: data.accountCode }).pmCode;
            }

            return {
                ID: 33017,
                responses: [33057, 33018, 33019],
                description: 'Withdraw',
                amount: data.amount,
                methodCode: methodCode,
                transactionTags: {
                    transactionTag: [
                        { name: 'cashiertype', value: 'HUB2' }
                    ]
                }
            };
        },

        withdraw: function(data) {
            var request = this.getRequestData(data);
            var modelConfig = this.get('config');
            var existingAccount = _.findWhere(this.get('account'), { code: data.storedAccountId });
            var existingAccountFields = existingAccount && existingAccount.accountFields
                && existingAccount.accountFields.field || [];
            var accountFields = this.get('accountFields') && this.get('accountFields').field || [];

            // Withdraw with 3D check: back-urls should always be present
            request = this.getBackUrls(request, 'withdraw', this.get('reDirectType'));

            // NB: TYPES OF REQUESTS:
            // 1. CC require actual accountCode as accountCode and empty specificParams
            // 2. Non-generic require accountId as accountCode and empty specificParams
            // 3. Generic require exact fields in specificParams as in accountFields

            // * Sending specificParams for wrong method or with wrong fields
            // will trigger no response from IMS at all and will lead to network error

            if (!this.get('isGeneric') && !this.isCustomGeneric(this.get('code'))) {
                request.accountCode = this.get('config').creditCard ? data.accountCode : data.accountId;
            } else if (modelConfig && modelConfig.accountFieldsMap) { // account has hardcore `accountFieldsMap`
                var fields = this._makeSimilarDataStructure(modelConfig.accountFieldsMap);
                request.specificParams = this.specParamsFormation(data, fields);
            } else if (existingAccountFields.length || accountFields.length) {
                request.specificParams =
                    this.specParamsFormation(data, this._mergeAccountFields(accountFields, existingAccountFields));
            }

            // additional params
            _.extend(request, _.pick(data, this.confirmedFields));

            if (config.get('cashierClientType')) {
                request.clienttype = config.get('cashierClientType');
            }

            if (!config.get('sendCashierMessagesToGS')) {
                request.xNoPlayermessageToGs = true;
            }

            return server.send(request);
        },

        _mergeAccountFields: function(possibleFields, existingFields) {
            possibleFields = possibleFields.filter((field) => !field.isHiddenField);

            var different = existingFields.filter(function(field) {
                return !_.findWhere(possibleFields, { name: field.name });
            });

            return different.concat(possibleFields.map(function(field) {
                var existing = _.findWhere(existingFields, { name: field.name });

                return existing ? existing : { name: field.name, value: null };
            }));
        },

        isCustomGeneric: function(methodName) {
            /*
             * TODO: need to investigate, may be we have to use methods from `cashier.config`
             */
            var customGenericMethods = ['PayPalViaSC'];

            return customGenericMethods.includes(methodName);
        },

        specParamsFormation: function(data, existing) {
            return existing
                .reduce(function(result, field) {
                    var name = field && field.name;
                    if (name) {
                        result[name] = data[name];
                    }
                    return result;
                }, {});
        },

        _makeSimilarDataStructure: function(data) {
            return _.values(data).map(function(nameOfField) {
                return { name: nameOfField };
            });
        }
    });

});
